export default __webpack_public_path__ + "assets/images/Payment_10.95422b.webp";